export const GROUP_ACTIONS_SIDE_PANEL = 'groups-actions-side-panel';
export const GROUP_ACTIONS_THREE_DOTS = 'groups-actions-three-dots';
